(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dingnest-instagram"] && !Shopify.designMode) return;
  try {
    
  function dnInitGallery(root) {
    var scope = root && root.nodeType === 1 ? root : document;
    var found = [];

    if (scope.nodeType === 1 && scope.matches && scope.matches('.dn-section--gram')) {
      found.push(scope);
    }
    Array.prototype.push.apply(found, scope.querySelectorAll('.dn-section--gram'));

    found.forEach(function (section) {
      if (section.dataset.dnGramInit === 'true') return;
      section.dataset.dnGramInit = 'true';

      var list = section.querySelector('[data-dn-gram-list]');
      if (!list) return;

      function step(direction) {
        var item = list.querySelector('.dn-gram__item');
        var amount = item ? item.getBoundingClientRect().width + 14 : list.clientWidth * 0.8;
        list.scrollBy({ left: amount * direction, behavior: 'smooth' });
      }

      var prev = section.querySelector('[data-dn-gram-prev]');
      var next = section.querySelector('[data-dn-gram-next]');

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { dnInitGallery(document); });
  } else {
    dnInitGallery(document);
  }

  document.addEventListener('shopify:section:load', function (event) { dnInitGallery(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dingnest-load-more"]) return;
  try {
    
  // Trae la pagina siguiente con fetch y anade sus tarjetas a la rejilla.
  // La URL sale de la actual, asi que arrastra filtros y orden sin tocar nada.
  function dnInitLoadMore(root) {
    var scope = root && root.nodeType === 1 ? root : document;
    var wraps = [];
    if (scope.nodeType === 1 && scope.matches && scope.matches('[data-dn-loadmore]')) wraps.push(scope);
    Array.prototype.push.apply(wraps, scope.querySelectorAll('[data-dn-loadmore]'));

    wraps.forEach(function (wrap) {
      if (wrap.dataset.dnLmInit === 'true') return;
      wrap.dataset.dnLmInit = 'true';

      var button = wrap.querySelector('[data-dn-loadmore-btn]');
      var counter = wrap.querySelector('[data-dn-loadmore-count]');
      var grid = document.querySelector('[data-testid="product-grid"]');
      if (!button || !grid) return;

      var lastPage = parseInt(grid.dataset.lastPage, 10) || 1;
      var page = 1;
      var params = new URLSearchParams(window.location.search);
      if (params.get('page')) page = parseInt(params.get('page'), 10) || 1;

      var total = parseInt(wrap.dataset.total, 10) || 0;
      var tpl = wrap.dataset.progress || '';

      function count() {
        return grid.querySelectorAll('.product-grid__item').length;
      }

      function paint() {
        if (!counter) return;
        if (!total) { counter.hidden = true; return; }
        counter.hidden = false;
        counter.textContent = (tpl || 'Showing [shown] of [total]')
          .replace('[shown]', count())
          .replace('[total]', total);
      }

      if (page >= lastPage) {
        button.hidden = true;
        paint();
        return;
      }

      button.hidden = false;

      // Con el boton operativo, la paginacion numerada sobra.
      if (wrap.dataset.hidePagination === 'true') {
        var nav = document.querySelector('.pagination');
        if (nav) nav.hidden = true;
      }

      button.addEventListener('click', function () {
        if (button.disabled) return;
        button.disabled = true;
        button.textContent = button.dataset.loading || 'Loading…';

        var url = new URL(window.location.href);
        url.searchParams.set('page', String(page + 1));

        fetch(url.href, { headers: { Accept: 'text/html' } })
          .then(function (r) {
            if (!r.ok) throw new Error('Request failed');
            return r.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var next = doc.querySelector('[data-testid="product-grid"]');
            if (!next) throw new Error('No grid');

            var items = next.querySelectorAll('.product-grid__item');
            if (!items.length) throw new Error('No items');

            var frag = document.createDocumentFragment();
            Array.prototype.forEach.call(items, function (li) {
              frag.appendChild(document.importNode(li, true));
            });
            grid.appendChild(frag);

            page += 1;
            paint();

            if (page >= lastPage) {
              button.hidden = true;
            } else {
              button.disabled = false;
              button.textContent = button.dataset.label || 'Show more';
            }
          })
          .catch(function () {
            // Si falla, devolvemos el boton a su sitio y dejamos la
            // paginacion visible para que nadie se quede atrapado.
            button.disabled = false;
            button.textContent = button.dataset.label || 'Show more';
            var nav = document.querySelector('.pagination');
            if (nav) nav.hidden = false;
          });
      });

      paint();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { dnInitLoadMore(document); });
  } else {
    dnInitLoadMore(document);
  }

  document.addEventListener('shopify:section:load', function (event) { dnInitLoadMore(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dingnest-marquee"] && !Shopify.designMode) return;
  try {
    
  // Rotacion de la barra de anuncios. Un mensaje visible cada vez.
  function dnInitMarquee(root) {
    var scope = root && root.nodeType === 1 ? root : document;
    var bars = [];
    if (scope.nodeType === 1 && scope.matches && scope.matches('[data-dn-marquee]')) bars.push(scope);
    Array.prototype.push.apply(bars, scope.querySelectorAll('[data-dn-marquee]'));

    bars.forEach(function (bar) {
      if (bar.dataset.dnMqInit === 'true') return;
      bar.dataset.dnMqInit = 'true';

      var slots = bar.querySelectorAll('[data-dn-mq-slot]');
      if (slots.length < 2) return;

      var wait = (parseInt(bar.dataset.interval, 10) || 5) * 1000;
      var index = 0;
      var timer = null;

      function show(next) {
        slots[index].classList.remove('is-active');
        slots[index].setAttribute('aria-hidden', 'true');
        index = next;
        slots[index].classList.add('is-active');
        slots[index].removeAttribute('aria-hidden');
      }

      function start() {
        if (timer) return;
        timer = window.setInterval(function () {
          show((index + 1) % slots.length);
        }, wait);
      }

      function stop() {
        if (!timer) return;
        window.clearInterval(timer);
        timer = null;
      }

      // Ni gastamos ciclos con la pestana en segundo plano ni seguimos
      // rotando mientras alguien esta leyendo con el raton encima.
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });

      if (bar.classList.contains('dn-marquee--pausable')) {
        bar.addEventListener('mouseenter', stop);
        bar.addEventListener('mouseleave', start);
        bar.addEventListener('focusin', stop);
        bar.addEventListener('focusout', start);
      }

      start();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { dnInitMarquee(document); });
  } else {
    dnInitMarquee(document);
  }

  document.addEventListener('shopify:section:load', function (event) { dnInitMarquee(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dingnest-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  function dnInitRecommendations(root) {
    var scope = root && root.nodeType === 1 ? root : document;
    var found = [];

    if (scope.nodeType === 1 && scope.matches && scope.matches('[data-dn-recommendations]')) {
      found.push(scope);
    }
    Array.prototype.push.apply(found, scope.querySelectorAll('[data-dn-recommendations]'));

    found.forEach(function (el) {
      var url = el.getAttribute('data-dn-rec-url');
      var list = el.querySelector('[data-dn-rec-list]');

      if (!url || !list || el.dataset.dnRecInit === 'true') return;
      el.dataset.dnRecInit = 'true';

      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error('Recommendations request failed: ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-dn-rec-list]');

          if (fresh && fresh.children.length) {
            list.innerHTML = fresh.innerHTML;
          } else {
            el.hidden = true;
          }
        })
        .catch(function () {
          list.innerHTML = '';
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      dnInitRecommendations(document);
    });
  } else {
    dnInitRecommendations(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    dnInitRecommendations(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dingnest-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  var EDGE = 6;

  function reduced(){
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function glide(el, to, done){
    var from = el.scrollLeft;
    var max = el.scrollWidth - el.clientWidth;
    var end = Math.max(0, Math.min(max, to));
    if (reduced() || Math.abs(end - from) < 2){
      el.scrollLeft = end;
      if (done) done();
      return;
    }
    var finished = false;
    var t0 = null;
    var dur = 380;
    function frame(t){
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / dur);
      var e = 1 - Math.pow(1 - k, 3);
      el.scrollLeft = from + (end - from) * e;
      if (k < 1){
        window.requestAnimationFrame(frame);
      } else {
        finished = true;
        if (done) done();
      }
    }
    window.requestAnimationFrame(frame);
    window.setTimeout(function(){
      if (finished) return;
      if (Math.abs(el.scrollLeft - end) > 2) el.scrollLeft = end;
      if (done) done();
    }, dur + 160);
  }

  function init(root){
    if (root.dataset.dnrevReady === '1') return;
    root.dataset.dnrevReady = '1';
    var track = root.querySelector('[data-dnrev-track]');
    if (!track) return;
    var prev = root.querySelector('[data-dnrev-prev]');
    var next = root.querySelector('[data-dnrev-next]');
    var dots = root.querySelector('[data-dnrev-dots]');

    function step(){
      var f = track.querySelector('.dnrev__item');
      if (!f) return track.clientWidth;
      var st = window.getComputedStyle(track);
      var gap = parseFloat(st.columnGap || st.gap || '0') || 0;
      return f.getBoundingClientRect().width + gap;
    }
    function pages(){
      return Math.max(1, Math.ceil(track.scrollWidth / Math.max(1, track.clientWidth)));
    }
    function sync(){
      var max = track.scrollWidth - track.clientWidth - EDGE;
      if (prev) prev.disabled = track.scrollLeft <= EDGE;
      if (next) next.disabled = track.scrollLeft >= max;
      if (dots && dots.children.length){
        var cur = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        Array.prototype.forEach.call(dots.children, function(d, i){
          d.classList.toggle('is-on', i === cur);
          d.setAttribute('aria-current', i === cur ? 'true' : 'false');
        });
      }
    }
    function build(){
      if (!dots) return;
      dots.innerHTML = '';
      var n = pages();
      if (n < 2){ sync(); return; }
      for (var i = 0; i < n; i++){
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'dnrev__dot';
        d.setAttribute('aria-label', 'Page ' + (i + 1));
        (function(idx){
          d.addEventListener('click', function(){
            glide(track, idx * track.clientWidth, sync);
          });
        })(i);
        dots.appendChild(d);
      }
      sync();
    }

    if (prev) prev.addEventListener('click', function(){ glide(track, track.scrollLeft - step(), sync); });
    if (next) next.addEventListener('click', function(){ glide(track, track.scrollLeft + step(), sync); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', build);
    build();
  }

  function boot(){
    document.querySelectorAll('[data-dnrev]').forEach(init);
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dingnest-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  function dnInitSticky(root) {
    var scope = root && root.nodeType === 1 ? root : document;
    var found = [];
    if (scope.nodeType === 1 && scope.matches && scope.matches('[data-dn-sticky]')) found.push(scope);
    Array.prototype.push.apply(found, scope.querySelectorAll('[data-dn-sticky]'));

    found.forEach(function (bar) {
      if (bar.dataset.pwStickyInit === 'true') return;
      bar.dataset.pwStickyInit = 'true';

      var watch = document.querySelector(bar.dataset.watch || '[data-dn-product-main]');

      if (!watch) {
        var threshold = parseInt(bar.dataset.showAfter, 10) || 600;
        var onScroll = function () {
          bar.hidden = window.scrollY < threshold;
        };
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return;
      }

      if (!('IntersectionObserver' in window)) {
        bar.hidden = false;
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.hidden = entry.isIntersecting;
          });
        },
        { rootMargin: '0px 0px -60% 0px' }
      );
      observer.observe(watch);

      var cta = bar.querySelector('[data-dn-sticky-cta]');
      if (cta && cta.dataset.target !== 'product') {
        cta.addEventListener('click', function (event) {
          event.preventDefault();
          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          // Al selector de talla, no al boton: sin variante elegida el boton no
          // puede anadir nada y obligaria a volver a subir.
          var dest = document.querySelector('.dn-variants') || document.getElementById('dn-buy-box') || watch;
          dest.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { dnInitSticky(document); });
  } else {
    dnInitSticky(document);
  }

  document.addEventListener('shopify:section:load', function (event) { dnInitSticky(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dingnest-video-reel"] && !Shopify.designMode) return;
  try {
    
  function dnInitReel(root) {
    var scope = root && root.nodeType === 1 ? root : document;
    var found = [];

    if (scope.nodeType === 1 && scope.matches && scope.matches('[data-dn-reel]')) found.push(scope);
    Array.prototype.push.apply(found, scope.querySelectorAll('[data-dn-reel]'));

    found.forEach(function (section) {
      if (section.dataset.dnReelInit === 'true') return;
      section.dataset.dnReelInit = 'true';

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var wantsAutoplay = section.dataset.autoplay === 'true' && !reduce;
      var cards = Array.prototype.slice.call(section.querySelectorAll('[data-dn-reel-card]'));

      cards.forEach(function (card) {
        var video = card.querySelector('video');
        if (!video) return;

        video.muted = true;
        video.setAttribute('muted', '');
        video.playsInline = true;
        video.loop = true;

        if (!wantsAutoplay) {
          video.removeAttribute('autoplay');
          video.pause();
        }

        var button = card.querySelector('[data-dn-reel-sound]');
        if (button) {
          button.addEventListener('click', function () {
            var turningOn = video.muted;

            // Solo un video con sonido a la vez.
            if (turningOn) {
              cards.forEach(function (other) {
                var v = other.querySelector('video');
                var b = other.querySelector('[data-dn-reel-sound]');
                if (v && v !== video) {
                  v.muted = true;
                  if (b) b.setAttribute('aria-pressed', 'false');
                }
              });
            }

            video.muted = !turningOn;
            button.setAttribute('aria-pressed', turningOn ? 'true' : 'false');

            var play = video.play();
            if (play && typeof play.catch === 'function') play.catch(function () {});
          });
        }
      });

      // Solo reproducen los videos visibles: ahorra datos y bateria.
      if (wantsAutoplay && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var video = entry.target.querySelector('video');
              if (!video) return;
              if (entry.isIntersecting) {
                var p = video.play();
                if (p && typeof p.catch === 'function') p.catch(function () {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.35 }
        );
        cards.forEach(function (card) { observer.observe(card); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { dnInitReel(document); });
  } else {
    dnInitReel(document);
  }

  document.addEventListener('shopify:section:load', function (event) { dnInitReel(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
